import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { notAuthGuard } from './guards/notAuth.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { inject } from '@angular/core';
import { AuthService } from './services/auth.service';
import { ExternalRedirectComponent } from './external-redirect/external-redirect.component';

export const routes: Routes = [
    { 
        path: 'login', 
        component: ExternalRedirectComponent, 
        canActivate: [notAuthGuard],
        resolve: {
            externalUrl: () => {
                return inject(AuthService).loginUrl();
            }
        }
    },
    
    {
        path: 'register',
        component: ExternalRedirectComponent,
        canActivate: [notAuthGuard],
        resolve: {
            externalUrl: () => {
                return inject(AuthService).registerUrl();
            }
        }
    },

    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
    },
    {
        path: 'dashboard',
        canActivate: [authGuard],
        loadComponent: () => import('./dashboard-page/dashboard.page').then((m) => m.DashboardPageComponent),
    },
    {
        path: 'brands',
        canActivate: [authGuard],
        loadComponent: () => import('./brands-page/brands.page').then((m) => m.BrandsPageComponent),
    },
    {
        path: 'brands/new',
        canActivate: [authGuard],
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () => import('./brand-editor-page/brand-editor.page').then((m) => m.BrandEditorPageComponent),
    },
    {
        path: 'brands/:brandId',
        canActivate: [authGuard],
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () => import('./brand-editor-page/brand-editor.page').then((m) => m.BrandEditorPageComponent),
    },
    {
        path: 'personas',
        canActivate: [authGuard],
        loadComponent: () => import('./personas-page/personas.page').then((m) => m.PersonasPageComponent),
    },
    {
        path: 'personas/new',
        canActivate: [authGuard],
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () => import('./persona-editor-page/persona-editor.page').then((m) => m.PersonaEditorPageComponent),
    },
    {
        path: 'personas/:personaId',
        canActivate: [authGuard],
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () => import('./persona-editor-page/persona-editor.page').then((m) => m.PersonaEditorPageComponent),
    },
    {
        path: 'scenarios',
        canActivate: [authGuard],
        loadComponent: () => import('./scenarios-page/scenarios.page').then((m) => m.ScenariosPageComponent),
    },
    {
        path: 'scenarios/new',
        canActivate: [authGuard],
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () => import('./scenario-editor-page/scenario-editor.page').then((m) => m.ScenarioEditorPageComponent),
    },
    {
        path: 'scenarios/:scenarioId',
        canActivate: [authGuard],
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () => import('./scenario-editor-page/scenario-editor.page').then((m) => m.ScenarioEditorPageComponent),
    },
    {
        path: 'runs',
        canActivate: [authGuard],
        loadComponent: () => import('./runs-page/runs.page').then((m) => m.RunsPageComponent),
    },
    {
        path: 'runs/:runId',
        canActivate: [authGuard],
        loadComponent: () => import('./run-detail-page/run-detail.page').then((m) => m.RunDetailPageComponent),
    },
    {
        path: 'retail-runs/:runId',
        canActivate: [authGuard],
        loadComponent: () => import('./retail-run-detail-page/retail-run-detail.page').then((m) => m.RetailRunDetailPageComponent),
    },
    {
        path: 'human-runs/:runId',
        canActivate: [authGuard],
        loadComponent: () => import('./human-run-detail-page/human-run-detail.page').then((m) => m.HumanRunDetailPageComponent),
    },
    {
        path: 'diagnostics',
        canActivate: [authGuard],
        loadComponent: () => import('./diagnostics-page/diagnostics.page').then((m) => m.DiagnosticsPageComponent),
    },
    {
        path: 'action-plans',
        canActivate: [authGuard],
        loadComponent: () => import('./action-plans-page/action-plans.page').then((m) => m.ActionPlansPageComponent),
    },
    {
        path: 'seo-plans',
        canActivate: [authGuard],
        loadComponent: () => import('./seo-plans-page/seo-plans.page').then((m) => m.SeoPlansPageComponent),
    },
    {
        path: 'experience-maps',
        canActivate: [authGuard],
        loadComponent: () => import('./experience-maps-page/experience-maps.page').then((m) => m.ExperienceMapsPageComponent),
    },
    {
        path: 'shopping-agent',
        canActivate: [authGuard],
        loadComponent: () => import('./shopping-agent-page/shopping-agent.page').then((m) => m.ShoppingAgentPageComponent),
    },
    {
        path: 'retail-agents',
        canActivate: [authGuard],
        loadComponent: () => import('./retail-agents-page/retail-agents.page').then((m) => m.RetailAgentsPageComponent),
    },
    {
        path: 'human-agent',
        canActivate: [authGuard],
        loadComponent: () => import('./human-agent-page/human-agent.page').then((m) => m.HumanAgentPageComponent),
    },
    {
        path: 'analyst-agent',
        canActivate: [authGuard],
        loadComponent: () => import('./adaptiv-agent/adaptiv-agent.component').then((m) => m.AdaptivAgentComponent),
    },
    {
        path: 'methodology',
        canActivate: [authGuard],
        loadComponent: () => import('./methodology-page/methodology.page').then((m) => m.MethodologyPageComponent),
    },
    {
        path: 'methodology/:agentType',
        canActivate: [authGuard],
        loadComponent: () => import('./agent-methodology-page/agent-methodology.page').then((m) => m.AgentMethodologyPageComponent),
    },
    {
        path: 'settings',
        canActivate: [authGuard],
        loadComponent: () => import('./settings-page/settings.page').then((m) => m.SettingsPageComponent),
    },
    {
        path: 'unauthorized',
        loadComponent: () => import('./unauthorized-page/unauthorized.page').then((m) => m.UnauthorizedPageComponent),
    },
    { path: '**', redirectTo: 'dashboard' }

];
